import React from 'react';
import { VirusIcon } from '@cp/ds/src/icons';
import { Tag } from '@cp/ds/src/components/tag';

export const BotCreatedTag = (props: { fake?: boolean }) => (
  <Tag sx={{ color: props.fake ? 'vk' : 'red' }}>
    <VirusIcon />
  </Tag>
);
